import * as React from 'react';
import './styles.scss';
import { Button, Modal } from 'antd';

const CustomModal: React.FC<any> = ({ children, isVisible, maskClosable, title, onClose, ...rest }) => {
    return (
        <>
            <Modal
                maskClosable={maskClosable}
                visible={isVisible}
                destroyOnClose={true}
                title={title}
                width={'90%'}
                style={{ height: '90vh' }}
                onCancel={() => onClose()}
                footer={[
                    <Button
                        key="back"
                        onClick={() => onClose()}
                        className="mr-2"
                    >
                        Cancel
                    </Button>,
                ]}
                {...rest}
            >
                {children}
            </Modal>
        </>
    );
};

export default CustomModal;





